import { Component, OnInit } from '@angular/core';
import { StateModel } from '../../../../models/state.model';
import { StateService } from '../../../../services/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fakeAsync } from '@angular/core/testing';
import { finalize } from 'rxjs';
import { NgIf } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';


@Component({
    standalone:true,
    imports:[FormsModule,NgIf],
    providers:[StateService],
    selector: 'state-form',
    templateUrl: './state-form.component.html',
    styleUrls: ['./state-form.component.css']
})
export class StateFormComponent implements OnInit {
    state!: StateModel;
    had!: string;
    errors!: string;  
    isRequesting!: boolean;

    constructor(private stateService: StateService,
        private route: ActivatedRoute, private router: Router) {}

    ngOnInit(): void {
        this.state = new StateModel();

        this.route.params.subscribe(p => {
            this.state.id = +p['id'];

            //console.log(p);

            if (this.state.id) {
                this.stateService.getState(this.state.id).subscribe(s => {
                    this.state = s;
                    this.had = 'Edit State';
                });
            }

            else {
                this.state.id = 0;
                this.had = 'New State';
            }

        });


    }


    submit() {
        if (this.state.id) {
            this.isRequesting = true;
            this.errors = '';
            this.stateService.update(this.state)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe(s => {
                this.router.navigate(['/admin/state/index']);
            },
                errors => this.errors = errors);
        }

        else {
            this.isRequesting = true;
            this.errors = '';
            this.stateService.create(this.state)
            .pipe(finalize(() => this.isRequesting = false))
                .subscribe(s => {
                this.router.navigate(['/admin/state/index']);
            },
                errors => this.errors = errors);
        }
    }
}
